export const FILTER_CONDITIONS = [
  { value: 'is', label: 'Include any' },
  { value: 'is_not', label: 'Exclude all' },
];

export const FILTER_CONDITIONS_WITH_AND = [
  { value: 'is', label: 'Include any' },
  { value: 'and', label: 'Include all' },
  { value: 'is_not', label: 'Exclude all' },
];

export const FILTER_COMPARISON_CONDITIONS = [
  { value: 'gt', label: 'Greater than' },
  { value: 'lt', label: 'Lesser than' },
  { value: 'gte', label: 'Greater than or equal to' },
  { value: 'lte', label: 'Lesser than or equal to' },
  { value: 'eq', label: 'Equals' },
];

export const FILTER_KINDS = [
  'number',
  'percent',
  'enum_boolean',
  'rel_tag',
  'rel_tag_multi',
  'date',
  'singleText',
  'enum',
];
